/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Account_Locked_Page_TitleInputs */

const de_login_account_locked_page_title = /** @type {(inputs: Login_Account_Locked_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung nicht möglich`)
};

/** @type {(inputs: Login_Account_Locked_Page_TitleInputs) => LocalizedString} */
const en_login_account_locked_page_title = de_login_account_locked_page_title;

/**

* @param {Login_Account_Locked_Page_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const login_account_locked_page_title = /** @type {((inputs?: Login_Account_Locked_Page_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Account_Locked_Page_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_account_locked_page_title(inputs)
	return en_login_account_locked_page_title(inputs)
});